import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fmtPct = (v) => {
  if (v === null || v === undefined) return "—";
  const sign = v > 0 ? "+" : "";
  return `${sign}${v.toFixed(2)}%`;
};

export const fmtNav = (v) => {
  if (v === null || v === undefined) return "—";
  return v >= 100 ? `₹${v.toFixed(2)}` : `₹${v.toFixed(4)}`;
};

export const fmtAum = (cr) => {
  if (!cr && cr !== 0) return "—";
  return `₹${cr.toLocaleString("en-IN")} Cr`;
};

export const cls = (v) => (v === null || v === undefined ? "text-sif-muted" : v >= 0 ? "gain" : "loss");
